import SignIn from '../pages/signin';
import SignUp from '../pages/signup';
import Profile from '../pages/profile';
import AllPosts from '../pages/managePosts';
import AllUsers from '../pages/manageUsers';
import Dashboard from '../pages/dashboard';
import BuyAndSell from '../pages/buy-sell';
import Wallet from '../pages/wallet';
import PassBook from '../pages/passbook';
import Login from '../pages/login';
import CustomerPage from '../pages/customer';
import CustomerOnboardingPage from '../pages/customer-onboarding';
import ResetPassword from '../pages/resetPassword';
//new
import ForcePassword from '../pages/forcePassword';
import EnterpriseSignup from 'pages/signup/enterprise';
import EntResetPassword from 'pages/resetPassword/enterprise_reset';
import AccountSelection from 'pages/account/accountSelection';
import withIdleTimer from 'shared/withIdleTimer/withIdleTimer';

//new screen 07-june-2023
import SipPage from 'pages/sip-old';
import SipPage1 from '../pages/sip'
import SipSavingPlan from 'pages/sip-old/sipSavingPlan';
// import PaymentSchedule from 'pages/sip-old/PaymentSchedule';
import GiftModule from 'pages/gift-module';
import ChartComponent from 'pages/priceCharts/ChartComponent';
import GoldSilverGraph from 'pages/priceCharts/GoldSilverGraph';
import SipRedirection from 'shared/common/sipRedirection/SipRedirection';
import Undertaking from 'pages/referral-undertaking';
import CashfreeLoad from 'pages/checkoutCashfree/CashfreeLoad';
import SignInSignUp from 'pages/signIn-signUp';
import CustomerDetails from 'pages/signIn-signUp/CustomerDetails';
import BuyCoinsBars from 'pages/buy-coins-bars';
import DeliveryOrders from 'pages/delivery-orders';
import MultimetalSIP from 'pages/sip/components/CreateSip';
import PaymentSchedule from 'pages/sip/components/PaymentSchedule';
import InvoiceDownload from 'pages/invoiceDownload';
import EasebuzzSuccess from 'pages/checkoutEasebuzz/EasebuzzSuccess';
import EasebuzzFailure from 'pages/checkoutEasebuzz/EasebuzzFailure';
import HandleRedirect from 'pages/handle-redirect';

const commonRouteMap = {
  SipRedirectPage: {
    path: '/manualSipData/:id',
    component: SipRedirection,
  },
  HandleRedirect: {
    path: '/handle-redirect',
    component: HandleRedirect,
  },
};
const publicRouteMap = {
  LogIn: {
    path: '/login',
    component: SignInSignUp,
  },
  SignIn: {
    path: '/signin',
    component: SignInSignUp,
  },
  LandingPage: {
    path: '/',
    component: SignInSignUp,
  },
  ReferralUndertaking: {
    path: '/undertaking',
    component: Undertaking,
  },
  SignUp: {
    path: '/signup',
    component: SignUp,
  },
  Enterprise: {
    path: '/enterprise',
    component: EnterpriseSignup,
  },
  ForgetPassword: {
    path: '/reset-password',
    component: ResetPassword,
  },
  //new
  ForcePassword: {
    path: '/change-password',
    component: ForcePassword,
  },
  EntForgetPassword: {
    path: '/ent-reset-password',
    component: EntResetPassword,
  },
  InvoiceDownloadRedirect: {
    path: '/invoice/pdf/:id',
    component: InvoiceDownload,
  }
};

const privateRouteMap = {
  Customers: {
    path: '/customers',
    component: withIdleTimer(CustomerPage),
  },
  Accounts: {
    path: '/accounts',
    component: withIdleTimer(AccountSelection),
  },
  CustomerCreate: {
    path: '/customer/create',
    component: withIdleTimer(CustomerOnboardingPage),
  },
  Profile: {
    path: '/profile',
    component: withIdleTimer(Profile),
  },
  CustomerDetails: {
    path: '/customer-details',
    component: withIdleTimer(CustomerDetails),
  },
  //sip plan
};

const customerRouteMap = {
  Dashboard: {
    path: '/dashboard',
    component: withIdleTimer(Dashboard),
  },
  PriceCharts: {
    path: '/price-charts',
    component: withIdleTimer(ChartComponent),
  },
  GoldVsSilver: {
    path: '/gold-silver',
    component: withIdleTimer(GoldSilverGraph),
  },
  Wallet: {
    // path: '/wallet',
    path: '/eb-wallet-withdrawal',
    component: withIdleTimer(Wallet),
  },
  AddPost: {
    path: '/passbook',
    component: withIdleTimer(PassBook),
  },
  DeliveryOrders: {
    path: '/delivery-orders',
    component: withIdleTimer(DeliveryOrders),
  },
  EasebuzzSuccess: {
    path: '/payment/easebuzz-success',
    component: EasebuzzSuccess,
  },
  EasebuzzFailure: {
    path: '/payment/easebuzz-failure',
    component: EasebuzzFailure,
  },
};

const fraudprivateRouteMap = {
  Sip: {
    path: '/sip',
    component: withIdleTimer(SipPage1),
  },
  SipDailySaving: {
    path: '/daily-saving',
    component: withIdleTimer(SipPage1),
  },
  SipPlan: {
    path: '/sip-plan',
    component: withIdleTimer(SipSavingPlan),
  },
  SipPaymentSchedule: {
    path: '/sip-payment-schedule/:id',
    // component: withIdleTimer(PaymentSchedule),
    component: withIdleTimer(PaymentSchedule),
  },
  // Gift: {
  //   path: '/gift',
  //   component: withIdleTimer(GiftModule),
  // },
  MultimetalSIP: {
    path: '/multimetal-sip',
    component: withIdleTimer(SipPage1),
  },
  BuySell: {
    path: '/buy-sell',
    component: withIdleTimer(BuyAndSell),
  },
  BuyCoinsBars :{
    path:'/buy-coins-bars',
    component: withIdleTimer(BuyCoinsBars)
  }
};

const adminRouteMap = {
  AllUsers: {
    path: '/users',
    component: AllUsers,
  },
};

export {
  commonRouteMap,
  publicRouteMap,
  privateRouteMap,
  customerRouteMap,
  adminRouteMap,
  fraudprivateRouteMap,
};
